import BlackBattersBox from "../assets/black-batters-box.svg";
import BlackPitchersBattersBox from "../assets/black-pitcher-perspective.svg";
import LightBattersBox from "../assets/light-batters-box.svg";
import LightPitchersBattersBox from "../assets/light-pitcher-perspective.svg";
import TMobileBattersBox from "../assets/tmobile-black-batters-box.svg";
import WhiteBattersBox from "../assets/white-batters-box.svg";
import WhitePitchersBattersBox from "../assets/white-pitcher-perspective.svg";
import { DisplayConfiguration, PitchPalette } from "../context/ConfigurationContext";
import { UITheme, VenueUIConfigOptions } from "../types/Config";

const white = "#FFF";
const black = "#000";
const bluish = "#E0E8F3";
const gray = "#3D3D3D";

export type PaletteConfiguration = {
  disconnect: string;
  background: string;
  strikeZone: string;
  infoBackground: string;
  infoText: string;
  battersBoxSrc: string;
  pitchersBoxSrc: string;
  strike: PitchPalette;
  ball: PitchPalette;
  inPlay: PitchPalette;
};

export type ScalingConfiguration = {
  height: number;
  width: number;
  multiplier: number;
};

const TMobileDisplay: PitchPalette = {
  header: "#EC0075",
  ball: "#EC0075",
  arch: "#EC0075",
};

const Themes: { [key: string]: PaletteConfiguration } = {
  white: {
    disconnect: black,
    background: white,
    strikeZone: black,
    infoBackground: bluish,
    infoText: black,
    battersBoxSrc: WhiteBattersBox,
    pitchersBoxSrc: WhitePitchersBattersBox,
    strike: {
      ball: "#E41D54",
      arch: "#FFB2B2",
      header: "#bf0d3e",
    },
    ball: {
      ball: "#21C95C",
      arch: "#BCEECE",
      header: "#164b29",
    },
    inPlay: {
      arch: "#618ee1",
      ball: "#2160da",
      header: "#15449f",
    },
  },
  light: {
    disconnect: black,
    background: bluish,
    strikeZone: black,
    infoBackground: white,
    infoText: black,
    battersBoxSrc: LightBattersBox,
    pitchersBoxSrc: LightPitchersBattersBox,
    strike: {
      ball: "#E41D54",
      arch: "#FB9696",
      header: "#bf0d3e",
    },
    ball: {
      ball: "#21C95C",
      arch: "#9BD9BE",
      header: "#164b29",
    },
    inPlay: {
      ball: "#2160da",
      arch: "#618ee1",
      header: "#15449f",
    },
  },
  dark: {
    disconnect: white,
    background: black,
    strikeZone: white,
    infoBackground: gray,
    infoText: white,
    battersBoxSrc: BlackBattersBox,
    pitchersBoxSrc: BlackPitchersBattersBox,
    strike: {
      ball: "#E41D54",
      arch: "#9D0707",
      header: "#bf0d3e",
    },
    ball: {
      ball: "#21C95C",
      arch: "#11652E",
      header: "#164b29",
    },
    inPlay: {
      ball: "#2160da",
      arch: "#618ee1",
      header: "#15449f",
    },
  },
  magenta: {
    disconnect: white,
    background: black,
    strikeZone: white,
    infoBackground: gray,
    infoText: white,
    battersBoxSrc: TMobileBattersBox,
    pitchersBoxSrc: BlackPitchersBattersBox,
    strike: {
      ...TMobileDisplay,
    },
    ball: {
      ...TMobileDisplay,
    },
    inPlay: {
      ...TMobileDisplay,
    },
  },
  "title-magenta": {
    disconnect: white,
    background: black,
    strikeZone: white,
    infoBackground: gray,
    infoText: white,
    battersBoxSrc: TMobileBattersBox,
    pitchersBoxSrc: BlackPitchersBattersBox,
    strike: {
      header: "#bf0d3e",
      ...TMobileDisplay,
      arch: "#FFB2B2",
      ball: "#E41D54",
    },
    ball: {
      header: "#164b29",
      ...TMobileDisplay,
      arch: "#BCEECE",
      ball: "#21C95C",
    },
    inPlay: {
      header: "#15449f",
      ...TMobileDisplay,
      arch: "#618ee1",
      ball: "#2160da",
    },
  },
  "arc-magenta": {
    disconnect: white,
    background: black,
    strikeZone: white,
    infoBackground: gray,
    infoText: white,
    battersBoxSrc: TMobileBattersBox,
    pitchersBoxSrc: BlackPitchersBattersBox,
    strike: {
      arch: "#FFB2B2",
      ball: "#E41D54",
      ...TMobileDisplay,
      header: "#bf0d3e",
    },
    ball: {
      ball: "#21C95C",
      arch: "#BCEECE",
      ...TMobileDisplay,
      header: "#164b29",
    },
    inPlay: {
      arch: "#618ee1",
      ball: "#2160da",
      ...TMobileDisplay,
      header: "#15449f",
    },
  },
};

export const defaultPalette: PaletteConfiguration = Themes["dark"];

export const getPalette = (value: UITheme): PaletteConfiguration => Themes[value];

export const defaultScaling: ScalingConfiguration = {
  height: 1080,
  width: 840,
  multiplier: 1.0,
};

export const createDisplayConfig = (value: VenueUIConfigOptions, pitchersView?: string): DisplayConfiguration => {
  return {
    ...value,
    displayAddtlInfo: value.showPitchSpeed || value.showPitchType || value.showLaunchAngle || value.showExitVelocity,
    isPitchersView: !!pitchersView,
  };
};
